<template>
  <div class="modal-overlay" @click.self="close">
    <div class="modal-content">
      <div class="modal-header">
        <h2>{{ isEdit ? '编辑学生' : '添加学生' }}</h2>
        <button class="close-btn" @click="close">&times;</button>
      </div>

      <form @submit.prevent="submit">
        <div class="form-group">
          <label for="name">姓名</label>
          <input id="name" v-model="form.name" required>
        </div>

        <div class="form-group">
          <label for="status">状态</label>
          <select id="status" v-model="form.status" required>
            <option v-for="option in statusOptions" :key="option.value" :value="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="birthday">生日</label>
          <input 
            id="birthday" 
            type="date" 
            v-model="form.birthday" 
            :max="today"
          >
        </div>

        <div class="form-actions">
          <button type="button" class="cancel-btn" @click="close">取消</button>
          <button type="submit" class="submit-btn">提交</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { useMutation } from '@vue/apollo-composable';
import { CREATE_STUDENT, UPDATE_STUDENT } from '../graphql/queries';

const props = defineProps({
  student: Object,
  isEdit: Boolean
});

const emit = defineEmits(['close', 'saved']);

const statusOptions = [
  { label: '正常', value: 'ACTIVE' },
  { label: '沒有課程', value: 'INACTIVE' },
  { label: '暫停', value: 'SUSPENDED' },
  { label: '已畢業', value: 'GRADUATED' },
  { label: '潛在', value: 'PROSPECTIVE' },
];

const today = computed(() => {
  const date = new Date();
  return date.toISOString().split('T')[0];
});

const form = ref({
  name: '',
  status: 'ACTIVE',
  birthday: ''
});

// Set initial form values when student prop changes
watch(() => props.student, (student) => {
  if (student) {
    form.value = {
      name: student.name,
      status: student.status,
      birthday: student.birthday || ''
    };
  } else {
    resetForm();
  }
}, { immediate: true });

const { mutate, loading } = useMutation(
  props.isEdit ? UPDATE_STUDENT : CREATE_STUDENT
);

function resetForm() {
  form.value = {
    name: '',
    status: 'ACTIVE',
    birthday: ''
  };
}

function close() {
  emit('close');
}

function submit() {
  const variables = props.isEdit
    ? {
        student_id: props.student.student_id,
        ...form.value,
        birthday: form.value.birthday || null
      }
    : {
        ...form.value,
        birthday: form.value.birthday || null
      };

  mutate(variables).then(() => {
    emit('saved');
  });
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  border-radius: 8px;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0;
}

form {
  padding: 20px;
}

.form-group {
  margin-bottom: 20px;
}

label {
  display: block;
  margin-bottom: 8px;
  font-weight: bold;
}

input, select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-sizing: border-box;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 30px;
}

.cancel-btn {
  padding: 10px 20px;
  background-color: #f5f5f5;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.submit-btn {
  padding: 10px 20px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
</style>